import { createRoot } from 'react-dom/client';

document.addEventListener('DOMContentLoaded', () => {
	const upgradePageEl = document.getElementById('bplUpgradePage');

	createRoot(upgradePageEl).render(<UpgradePageContent />);
});

const UpgradePageContent = () => {
	return <div className='fsUpgradePrice'>
		<style dangerouslySetInnerHTML={{
			__html: `
			#bplUpgradePage {
				.fsUpgradePrice {
					min-width: 100%;
					height: 940px;
					max-height: 940px;
					overflow: hidden;
				}
			}
			`.replace(/\s+/g, ' ')
		}} />

		<iframe src="https://wp.freemius.com/pricing/?plugin_id=14562&amp;plugin_public_key=pk_7f62446a2a53154c56c36346db2fa" width="100%" height="800px" scrolling="no" frameBorder="0" style={{ background: 'transparent', width: '1px', minWidth: '100%', height: '940px' }}></iframe>
	</div>
}